import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

function formatErr(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (e) {
      setErr(formatErr(e.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: "var(--bg-color)" }}>
      <div className="w-full max-w-sm">
        <a href="/" className="font-heading text-xl font-semibold tracking-tight">
          Bishal<span style={{ color: "var(--accent-color)" }}>.</span>
        </a>
        <h1 className="mt-8 font-heading text-3xl font-semibold tracking-tight">Studio Admin</h1>
        <p className="mt-2 text-sm" style={{ color: "var(--text-secondary)" }}>Sign in to manage your work & settings.</p>

        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="login-form">
          <div>
            <label className="text-xs uppercase tracking-widest" style={{ color: "var(--text-secondary)" }}>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="login-email"
              className="mt-2 w-full rounded-lg border bg-transparent px-4 py-3 text-sm outline-none focus:border-[var(--accent-color)] transition-colors"
              style={{ borderColor: "var(--border-color)" }}
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest" style={{ color: "var(--text-secondary)" }}>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="login-password"
              className="mt-2 w-full rounded-lg border bg-transparent px-4 py-3 text-sm outline-none focus:border-[var(--accent-color)] transition-colors"
              style={{ borderColor: "var(--border-color)" }}
            />
          </div>
          {err && <p className="text-sm text-red-400" data-testid="login-error">{err}</p>}
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full rounded-full py-3 text-sm font-medium text-black transition-opacity hover:opacity-90 disabled:opacity-60"
            style={{ background: "var(--accent-color)" }}
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
